import React, { useRef, useState } from "react";
import AboutSection from "./aboutSection";
import Contact from "./contact";
import Language from "./language";
import Expertise from "./expertise";
import { TbPointFilled, TbTemplate } from "react-icons/tb";
import { useStores } from "../../store/index";
import { useObserver } from "mobx-react";
import { useReactToPrint } from "react-to-print";
import "./resume.css";

export function WebsiteLinks() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className=" flex flex-col items-center justify-center  w-[80%] mx-auto my-5 md:mt-8 lg:mt-10 ">
      {(ResumeStore.resumeBuilder.websites.length ?? 0) > 0 && (
        <h1 id="websitelinks" className="blackh1">
          Links
        </h1>
      )}
      <div className="flex text-white flex-col items-start my-2 gap-1 w-[70%] mx-auto text-xs lg:text-sm">
        {(ResumeStore.resumeBuilder.websites || []).map((item, index) => (
          <div className="flex  items-center text-sm" key={index}>
            <TbPointFilled className="mr-1" />
            <a
              href={item.link}
              target="_blank"
              className="max-w-[90%] break-words"
            >
              {item.label}
            </a>
          </div>
        ))}
      </div>
    </div>
  ));
}

export function Experience() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className=" w-[90%] text-xs md:mt-[20px] lg:mt-[60px]">
      {(ResumeStore.resumeBuilder.employementHistory.length ?? 0) > 0 && (
        <h1 id="experience" className="h1tag">
          Experience
        </h1>
      )}

      {(ResumeStore.resumeBuilder.employementHistory || []).map(
        (item, index) => (
          <div
            key={index}
            className="flex flex-col text-justify mt-1 ml-2 gap-1 w-full  text-sm pt-3"
          >
            <p className="text-lg font-extrabold">
              {" "}
              <b> {`${item?.jobTitle} `} </b> {` at  ${item?.company}`}
            </p>
            <p className="text-sm md:text-base lg:text-md font-extrabold">{`${item?.startDate} -- ${item?.endDate}`}</p>
            <p>{item?.city}</p>
            <p className="w-full break-words text-justify">
              {item?.description}
            </p>
          </div>
        )
      )}
    </div>
  ));
}
export function Education() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className="w-[90%] mt-5 md:mt-8 lg:mt-10 ">
      {(ResumeStore.resumeBuilder.education.length ?? 0) > 0 && (
        <h1 id="education" className="h1tag">
          Education
        </h1>
      )}
      {(ResumeStore.resumeBuilder.education || []).map((item, index) => (
        <div
          className="flex flex-col text-justify mt-1 ml-2 gap-1 w-full text-sm pt-3"
          key={index}
        >
          <p className="text-lg font-extrabold">{item?.degree}</p>
          <p className="text-lg font-extrabold">{item?.school}</p>
          <p>{`${item?.startDate} -- ${item?.endDate}`}</p>
          <p>{item?.city}</p>
          <p className="break-words text-justify">{item?.description}</p>
        </div>
      ))}
    </div>
  ));
}

export function Internships() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className="w-[90%] mt-5 text-sm md:mt-8 lg:mt-10">
      {(ResumeStore.resumeBuilder.internships.length ?? 0) > 0 && (
        <h1 id="internships" className="h1tag">
          Internships
        </h1>
      )}
      {(ResumeStore.resumeBuilder.internships || []).map((item, index) => (
        <div className="flex flex-col text-justify mt-1 ml-2 gap-1 w-full text-sm pt-3">
          <p className="text-lg font-extrabold">
            {item?.jobTitle} at {item?.employer}
          </p>
          <p className="text-sm md:text-base lg:text-md font-extrabold">
            {item?.startDate} -- {item?.endDate}
          </p>
          <p>{item?.city}</p>
          <p className="break-words text-justify">{item?.description}</p>
        </div>
      ))}
    </div>
  ));
}

export function References() {
  const { ResumeStore } = useStores();
  return useObserver(() => (
    <div className=" flex flex-col items-center justify-center  w-[80%] mx-auto my-5 md:mt-8 lg:mt-10">
      {(ResumeStore.resumeBuilder.references.length ?? 0) > 0 && (
        <h1 id="references" className="blackh1">
          References
        </h1>
      )}
      <div className="flex text-white flex-col items-start my-2 gap-1 w-[100%] md:w-[70%] mx-auto lg:text-sm">
        {(ResumeStore.resumeBuilder.references || []).map((item, index) => (
          <div
            className="mt-1 ml-2 gap-1 flex  flex-col text-sm justify-start items-start"
            key={index}
          >
            <b>
              <p>
                {item?.referentsName} at {item?.company}
              </p>
            </b>
            <p className=" w-[90%]">{item?.email}</p>
            <p>{item.phone}</p>
          </div>
        ))}
      </div>
    </div>
  ));
}

export function Courses() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className=" flex flex-col items-center justify-center  w-[80%] mx-auto my-5 md:mt-8 lg:mt-10">
      {(ResumeStore?.resumeBuilder?.courses?.length ?? 0) > 0 && (
        <h1 id="courses" className="blackh1">
          Courses
        </h1>
      )}
      <div className="flex text-white flex-col items-start my-2 gap-1 w-[90%] md:w-[70%] mx-auto lg:text-sm">
        {(ResumeStore?.resumeBuilder?.courses || []).map((item, index) => (
          <div
            className="mt-1 md:ml-2 gap-1 flex  flex-col justify-start items-start text-sm"
            key={index}
          >
            <b>
              <p>{item?.course}</p>
            </b>
            <p>{item?.institution}</p>
            <p>
              {item?.startDate} -- {item?.endDate}
            </p>
          </div>
        ))}
      </div>
    </div>
  ));
}

export function ExtraActivities() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className="w-[90%] mt-5 md:mt-8 lg:mt-10 ">
      {(ResumeStore.resumeBuilder.extraCurricularActivities.length ?? 0) >
        0 && <h1 className="h2tag">Extra-curricular Activities</h1>}
      {(ResumeStore?.resumeBuilder?.extraCurricularActivities || []).map(
        (item, index) => (
          <div
            key={index}
            className="flex flex-col mt-1 ml-2 gap-1 w-full text-sm"
          >
            <p className="text-lg font-extrabold">
              {item?.functionTitle} at {item?.employer}
            </p>
            <p>
              {item?.startDate} -- {item?.endDate}
            </p>
            <p>{item?.city}</p>
            <p className="break-words text-justify pb-5">{item?.description}</p>
          </div>
        )
      )}
    </div>
  ));
}

export function Hobbies() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className=" flex flex-col items-center justify-center  w-[80%] mx-auto my-5 md:mt-8 lg:mt-10 ">
      {(ResumeStore.resumeBuilder.hobbies.length ?? 0) > 0 && (
        <h1 id="hobbies" className="blackh1">
          Hobbies
        </h1>
      )}
      <div className="flex text-white flex-col items-start my-2 gap-1 w-[70%] mx-auto text-xs lg:text-sm">
        {(ResumeStore.resumeBuilder.hobbies || []).map((item, index) => (
          <div className="flex  items-center text-sm" key={index}>
            <TbPointFilled className="mr-1" />
            <p className="max-w-[90%] break-words">{item.toString()}</p>
          </div>
        ))}
      </div>
    </div>
  ));
}

export function MainDetails() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className="flex flex-col mt-2 md:my-5 lg:my-5 pl-5 md:pl-0">
      <p className="name text-3xl text-primary font-bold pt-0 md:text-[40px]">
        {ResumeStore.resumeBuilder.personalDetails?.firstName ?? "RICHARD"}
      </p>
      <p className="text-black md:text-lg font-bold lg:text-lg text-xl pb-1 md:pb-4 lg:pb-4">
        {ResumeStore.resumeBuilder.personalDetails?.lastName ?? "Sandez"}
      </p>
      <p className="text-gray-500 text-center md:text-2xl lg:text-2xl text-lg ml-5 md:ml-28">
        {ResumeStore.resumeBuilder.personalDetails?.jobTitle ??
          "Product Designer"}
      </p>
      <p className="md:absolute lg:absolute md:px-3 lg:px-3 py-3 text-black right-0 md:right-1">
        {ResumeStore.resumeBuilder.personalDetails.dateOfBirth}
      </p>
    </div>
  ));
}

export function ResumeProfile() {
  const { ResumeStore } = useStores();

  return useObserver(() => (
    <div className="flex flex-col  w-[80%] my-3 md:mt-5 lg:mt-8">
      <img
        src={
          ResumeStore.resumeBuilder?.profile ??
          "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"
        }
        alt=" no image"
        className="w-[100px] h-[100px] md:w-[200px] md:h-[200px] rounded-full border-4 ml-[20%] lg:ml-[30%] -mt-[0%] border-resume_primary  object-cover "
      />
    </div>
  ));
}

export function DownloadResume({ onClick }) {
  return useObserver(() => (
    <button
      className="px-4 py-2 items-end bg-primary ml-auto mr-2 text-white rounded-lg my-3 mt-5"
      onClick={onClick}
    >
      Download PDF
    </button>
  ));
}

function ResumeOutput({ handleShowResume }) {
  const [isDownloadClicked, setIsDownloadClicked] = useState(false);

  const { ResumeStore } = useStores();
  // const resumeRef = useRef(null);

  // const handleDownload = () => {
  //     try {
  //         const resumeElement = document.getElementById('resume-output');

  //         if (!resumeElement) {
  //             console.error('Resume element not found.');
  //             return;
  //         }

  //         // const experienceId = document.getElementById("experience");
  //         // // add "download" className to experience id
  //         // experienceId.classList.add("download");

  //         const h1tag = document.getElementsByClassName("h1tag");
  //         const blackh1 = document.getElementsByClassName("blackh1");

  //         for (let i = 0; i < h1tag.length; i++) {
  //             h1tag[i].classList.add("download");
  //         }

  //         for (let i = 0; i < blackh1.length; i++) {
  //             blackh1[i].classList.add("download");
  //         }

  //         console.log('Generating canvas...');
  //         html2canvas(resumeElement).then(canvas => {
  //             console.log('Canvas generated:', canvas);

  //             const pdf = new html2pdf(canvas, {
  //                 margin: 10,
  //                 filename: 'resume.pdf',
  //                 image: { type: 'jpeg', quality: 5 },
  //                 html2canvas: { scale: 2 },
  //                 jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  //             });

  //             pdf.save('resume.pdf');
  //             console.log('PDF saved');

  //             setTimeout(() => {
  //                 setIsDownloadClicked(false);
  //                 for (let i = 0; i < h1tag.length; i++) {
  //                     h1tag[i].classList.remove("download");
  //                 }
  //                 for (let i = 0; i < blackh1.length; i++) {
  //                     blackh1[i].classList.remove("download");
  //                 }
  //             }, 100);

  //         });
  //     } catch (error) {
  //         console.error('Error generating and downloading resume:', error);
  //     }
  // };
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  const closeResume = () => {
    if (handleShowResume) {
      handleShowResume();
    }
    ResumeStore.setResumeShow(false);
  };

  return useObserver(() => (
    <div
      id="resume"
      className="flex flex-col items-center max-w-full justify-center"
    >
      {/* <button className=' flex items-center justify-center ml-auto hover:bg-primary text-gray-500 px-4 py-2 rounded-lg my-3 mr-2'>
                    <TbTemplate />
                    Select Template
                </button> */}

      <DownloadResume onClick={handleDownload} />

      <div
        ref={resumeRef}
        className="gil-reg flex relative h-full w-full mb-2 shadow-2xl  no-break clearfix overflow-x-auto"
      >
        {/* <div className="w-full flex absolute bg-primary h-[140px]  top-[90px]">
          <img
            src={
              ResumeStore.resumeBuilder?.profile ??
              "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"
            }
            alt=" no image"
            className=" w-[200px] h-[200px] rounded-full border-4 ml-[80px] -mt-[5%] border-resume_primary  object-cover "
          />
          <div className="flex flex-col md:ml-28">
            <p className="name">
              {ResumeStore.resumeBuilder.personalDetails?.firstName ??
                "RICHARD"}
            </p>
            <p className="text-black md:text-lg font-bold lg:text-lg text-xl pb-4">
              {ResumeStore.resumeBuilder.personalDetails?.lastName ?? "Sandez"}
            </p>
            <p className="text-white text-center md:text-2xl lg:text-2xl text-xl">
              {ResumeStore.resumeBuilder.personalDetails?.jobTitle ??
                "Product Designer"}
            </p>
          </div>
          <p className="absolute px-3 py-3 text-white right-1">
            {ResumeStore.resumeBuilder.personalDetails.dateOfBirth}
          </p>
        </div> */}
        <div className="ml-[6%] h-full pl-2 bg-gray-950 w-[40%] justify-center items-center">
          <ResumeProfile />
          <AboutSection />
          <Contact />
          <Expertise />
          <Courses />
          <WebsiteLinks />
          <Language />
          <References />
          <Hobbies />
        </div>
        <div className=" h-full w-[60%] pl-5">
          <MainDetails />
          <Experience />
          <Education />

          <Internships />
          {/* <Summary /> */}
          <ExtraActivities />
        </div>
      </div>
      <div className="flex gap-2">
        {/* <button className=' md:hidden lg:hidden flex  items-center justify-end px-4 py-2 bg-primary text-white rounded-full my-3 border-none ' onClick={handleDownload} >
          Download  PDF
        </button> */}

        <button
          onClick={closeResume}
          className="md:hidden lg:hidden flex items-center px-4 py-2 bg-primary text-white rounded-full my-3 border-none "
        >
          Close
        </button>
      </div>
    </div>
  ));
}

export default ResumeOutput;

// const handleDownload = async () => {
//     const resumeElement = resumeRef.current;

//     if (!resumeElement) {
//         console.error('Resume element not found.');
//         return;
//     }

//     try {
//         const dataUrl = await domtoimage.toPng(resumeElement, { quality: 1 });
//         const pdf = new jsPDF('p', 'mm', 'a4');
//         pdf.addImage(dataUrl, 'PNG', 10, 10, pdf.internal.pageSize.getWidth() - 20, pdf.internal.pageSize.getHeight() - 20);
//         pdf.save('resume.pdf');
//     } catch (error) {
//         console.error('Error generating and downloading resume:', error);
//     }
// };
